module.exports = __webpack_public_path__ + "static/favicon.0692c04b.ico";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/favicon.ico
// module id = 265
// module chunks = 79611799117203